import Page3 from '../../features/MarketingDigital.feature/page3';

export default function Marketing() {
  return (
    <>
      <Page3></Page3>
    </>
  );
}
